<div class="chart-treemap">
  <apx-chart *ngIf="chartOptions"
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [dataLabels]="chartOptions.dataLabels"
    [plotOptions]="chartOptions.plotOptions"
    [title]="chartOptions.title"
    [colors]="chartOptions.colors"
    [tooltip]="chartOptions.tooltip"
    class="d-block">
  </apx-chart>
</div>